import type { StaticColors } from './types'

/**
 * safeapp olive-green static colors.
 *
 * Drop-in replacement for packages/theme/src/palettes/static.ts in
 * safe-global/safe-wallet-monorepo. Static colors remain constant regardless
 * of light/dark mode. `textBrand` (used on dark/static surfaces) is the
 * bright dark-mode brand olive (--sa-olive, dark). Hex values mirror theme/tokens.json in
 * chews/safeapp — keep in sync (see theme/safe-ui-overlay/README.md).
 */
const staticColors: StaticColors = {
  main: '#1A1D14',
  light: '#63665C',
  primary: '#FFFFFF',
  textSecondary: '#9A9E90',
  textBrand: '#98A65A',
}

export default staticColors
